import { F0Box, F0Text } from '@factorialco/f0-react'

interface CompensationPlanAssignmentsProps {
  planId: string
  periodId: string
}

export function CompensationPlanAssignments({
  planId,
  periodId,
}: CompensationPlanAssignmentsProps) {
  return (
    <F0Box padding="lg">
      <F0Text content={`Plan ID: ${planId}`} />
      <F0Text content={`Period ID: ${periodId}`} />
    </F0Box>
  )
}
